import PortalRequestsListView from '../../components/portal/PortalRequestsListView'

const PortalBookings = ({}) => {


    return (
        <>
            <section className='home__query'>
                <div className='home__query__content wrap'>
                    <PortalRequestsListView
                        stageOptions={['Handed to Ops/Send welcome email', 'Preliminary brief sent', 'Passports & catering confirmed', 'Slots/Permits confirmed, final brief sent']}
                        />

                    
                </div>
            </section>
        </>
    )


}


export default PortalBookings